// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"413888cd","322":"387925f9","336":"c4f06505","531":"059ab443","699":"cfb4e35d","738":"0b3cf1e9","968":"238190a6"}[chunkId] + ".chunk.js";
};